import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  Section,
  Container,
  Grid,
  Col,
  Flex,
  SectionHeader,
  SanityBlockContent,
} from '../../common';
import { getIcon } from '../../../utils';

// const StyledTestimonial = styled.div`
//   background-color: ${(props) => props.$bgColor};
//   color: ${(props) => props.$color};
//   svg {
//     color: ${(props) => props.$svgColor};
//   }
// `;

const StyledSection = styled((props) => <Section {...props} />)`
  background-color: ${(props) => props.$bgColor};
  & span {
    color: ${(props) => props.$spanColor};
  }
  padding-top: ${(props) => props.$paddingTop};
  padding-bottom: ${(props) => props.$paddingBottom};
`;

const StyledTagline = styled.span`
  color: ${(props) => props.$spanColor};
`;

const StyledIcon = styled.div`
  color: ${(props) => props.$color};
`;

const StyledAuthor = styled.p`
  color: ${(props) => props.$color};
`;

const StyledTestimonial = styled.div`
  background-color: ${(props) => props.$bgColor};
  color: ${(props) => props.$color};
  svg {
    color: ${(props) => props.$svgColor};
  }
`;

const TrustLogos = ({ sanity, page, section }) => {
  const { colors, trustLogos } = sanity;

  // Calculate the number of columns, but make sure it doesn't exceed 6
  const numColumns = Math.min(section?.trustLogos?.length || 1, 6);

  let gridClasses = '';

  switch (numColumns) {
    case 1:
      gridClasses = 'grid-cols-1 lg:grid-cols-1 max-w-xl';
      break;
    case 2:
      gridClasses = 'grid-cols-2 lg:grid-cols-2 max-w-xl';
      break;
    case 3:
      gridClasses = 'grid-cols-2 lg:grid-cols-3 max-w-xl';
      break;
    case 4:
      gridClasses = 'grid-cols-2 lg:grid-cols-4 max-w-2xl';
      break;
    case 5:
      gridClasses = 'grid-cols-2 lg:grid-cols-5 max-w-4xl';
      break;
    case 6:
      gridClasses = 'grid-cols-2 lg:grid-cols-6';
      break;
    default:
      gridClasses = 'grid-cols-2 lg:grid-cols-3 max-w-xl';
  }

  const logoWidthStyle = {
    maxWidth: 'calc(100% / 6)',
  };

  const justifyContent = numColumns < 6 ? 'justify-center' : 'justify-around';

  return (
    <Section
      padding="sm"
      bgColor={colors?.neutral?.white}
      h2Color={colors?.neutral?.darker}
      h3Color={colors?.primary?.dark}
    >
      <Container classes="max-w-md px-4 sm:max-w-3xl lg:max-w-7xl mb-8 lg:mb-0">
        <SectionHeader
          sanity={sanity}
          tagline={section?.header?.tagline}
          headline={section?.header?.headline}
          description={section?.header?._rawDescription}
          classes="mb-12 lg:mb-0 mt-4"
        />
        <div className="flex justify-center">
          <Grid
            classes={`gap-x-12 gap-y-12 lg:gap-y-4 items-center mx-auto ${gridClasses} ${justifyContent}`}
          >
            {section?.trustLogos?.map((logo) => (
              <Col
                classes="flex justify-center items-center"
                key={logo?._key}
                style={logoWidthStyle}
              >
                <Container padding="none">
                  <GatsbyImage
                    image={logo?.image?.asset?.gatsbyImageData}
                    className="transition hover:scale-105"
                    alt={logo?.image?.alt}
                    loading="lazy"
                  />
                </Container>
              </Col>
            ))}
          </Grid>
        </div>
      </Container>
    </Section>
  );
};

export { TrustLogos };
